// extracted by mini-css-extract-plugin
module.exports = {"button":"_0fd55ca845--button--EOKhM","selected":"_0fd55ca845--selected--Nnvwn","block":"_0fd55ca845--block--b8LQX"};